"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const States_1 = require("../../States");
const plugins_1 = require("./../plugins");
const Cesium = window.Cesium;
/* LOG
    * removed compund controls (14/06/2021)
*/
class GlobeController extends plugins_1.FdmPlugin {
    constructor() {
        super(...arguments);
        this.controls = {
            transparency: { value: 0.2, type: 'slider', min: 0, max: 1, step: 0.01, noshow: true },
            globeTransparency: { value: 1, type: 'slider', min: 0, max: 1, step: 0.01, adjust: 'trans', noshow: true },
            clipping: { value: false, type: 'check' },
            boxTransparency: { value: 0.2, type: 'slider', min: 0, max: 0.4, step: 0.01, noshow: true },
            size: { value: 50, type: 'slider', min: 1, max: 300, step: 1, adjust: 'size', noshow: true },
        };
        this.entityPos = null;
        this.cameraMoveEventListener = null;
        this.counter = 0;
        this.mapService = null;
    }
    itemInjected() {
        this.mapService = this.services.mapService;
        this.mapService.viewer.scene.screenSpaceCameraController.enableCollisionDetection = false;
        this.updateTransparency();
        this.mapService.viewer.scene.camera.percentageChanged = 0.002;
        this.cameraMoveEventListener = this.mapService.viewer.scene.camera.changed.addEventListener((info) => {
            if (this.controls.clipping.value) {
                this.calcClippingMatrix();
            }
        });
        let me = this;
        this.entity('box', this.mapService.viewer.entities.add({
            show: this.controls.clipping.value,
            type: 'clipper',
            position: new Cesium.CallbackProperty(() => {
                let check = this.getCameraPosition();
                if (check) {
                    me.entityPos = check;
                }
                return me.entityPos;
            }, false),
            box: {
                dimensions: new Cesium.Cartesian3(this.controls.size.value, this.controls.size.value, 5000),
                material: Cesium.Color.WHITE.withAlpha(this.controls.boxTransparency.value),
                outline: true,
                outlineColor: Cesium.Color.WHITE.withAlpha(0.3),
            },
        }));
        this.updateClip();
        this.mapService.viewer.scene.globe.backFaceCulling = true;
        this.mapService.viewer.scene.globe.showSkirts = true;
        this.refresh();
    }
    /*
    Some reusable Cesium viewer helper functions
*/
    getCameraPosition() {
        let ret = null;
        let middle = new Cesium.Cartesian2(this.mapService.viewer.scene.canvas.width / 2.0, this.mapService.viewer.scene.canvas.height / 2.0);
        ret = this.services.measureHelper.pickRay(middle);
        // let camerapos = this.mapService.viewer.scene.camera.position;
        // let rect = this.mapService.viewer.scene.camera.computeViewRectangle();
        if (this.services.measureHelper.pickedCartesian) {
            // ret = this.measureHelper.pickedCartesian;
        }
        // ret = this.mapService.viewer.scene.camera.pickEllipsoid(middle);
        // console.log('@@', middle);
        return ret;
    }
    ;
    updateClip() {
        let neg = -(this.controls.size.value / 2);
        let entity = this.entity('box');
        this.mapService.viewer.scene.globe.clippingPlanes = new Cesium.ClippingPlaneCollection({
            modelMatrix: entity.computeModelMatrix(Cesium.JulianDate.now()),
            planes: [
                new Cesium.ClippingPlane(new Cesium.Cartesian3(1.0, 0.0, 0.0), neg),
                new Cesium.ClippingPlane(new Cesium.Cartesian3(-1.0, 0.0, 0.0), neg),
                new Cesium.ClippingPlane(new Cesium.Cartesian3(0.0, 1.0, 0.0), neg),
                new Cesium.ClippingPlane(new Cesium.Cartesian3(0.0, -1.0, 0.0), neg),
            ],
            edgeWidth: 2,
            edgeColor: Cesium.Color.PINK,
            enabled: true,
        });
    }
    updateTransparency() {
        // TODO : Also make controllers for near and far meters control
        this.mapService.viewer.scene.globe.translucency.frontFaceAlphaByDistance = new Cesium.NearFarScalar(10, this.controls.transparency.value, 1000, this.controls.globeTransparency.value);
    }
    calcClippingMatrix() {
        if (this.controls.clipping.value) {
            let entity = this.entity('box');
            if (this.mapService.viewer.scene.globe && this.mapService.viewer.scene.globe.clippingPlanes && this.mapService.viewer.scene.globe.clippingPlanes.modelMatrix && entity) {
                // console.log('!');
                this.mapService.viewer.scene.globe.clippingPlanes.modelMatrix = entity.computeModelMatrix(Cesium.JulianDate.now());
            }
        }
    }
    refresh(newvalue = null, section = null) {
        // check in with mama
        super.refresh(newvalue, section);
        // this.mapService.viewer.scene.globe.translucency.frontFaceAlphaByDistance.nearValue = this.controls.transparency.value;
        // this.mapService.viewer.scene.globe.translucency.frontFaceAlphaByDistance.farValue = 1;
        this.mapService.viewer.scene.globe.clippingPlanes.enabled = this.controls.clipping.value;
        if (section && section.adjust && section.adjust == 'trans') {
            this.updateTransparency();
        }
        let entity = this.entity('box');
        if (this.controls.clipping.value) {
            this.turnOn(['boxTransparency', 'size']);
            this.turnOff(['transparency', 'globeTransparency']);
            this.mapService.viewer.scene.globe.translucency.enabled = false;
            this.services.sceneController.report(this.id, States_1.A.TRANSPARENT_TERRAIN, States_1.TURN.OFF);
            if (entity) {
                entity.show = this.controls.clipping.value;
                this.calcClippingMatrix();
                entity.box.material = Cesium.Color.WHITE.withAlpha(this.controls.boxTransparency.value);
                entity.box.outlineColor = Cesium.Color.WHITE.withAlpha(this.controls.boxTransparency.value * 1.3);
            }
            if (section && section['adjust'] && section.adjust == 'size' && entity) {
                // console.log('@@@', this.entity );
                entity.box.dimensions._value.x = this.controls.size.value;
                entity.box.dimensions._value.y = this.controls.size.value;
                this.updateClip();
            }
        }
        else {
            this.mapService.viewer.scene.globe.translucency.enabled = true;
            this.services.sceneController.report(this.id, States_1.A.TRANSPARENT_TERRAIN, States_1.TURN.ON);
            this.turnOff(['boxTransparency', 'size']);
            this.turnOn(['transparency', 'globeTransparency']);
            if (entity) {
                entity.show = this.controls.clipping.value;
            }
        }
    }
    end() {
        if (this.mapService.viewer) {
            this.mapService.viewer.scene.screenSpaceCameraController.enableCollisionDetection = true;
            this.mapService.viewer.scene.globe.translucency.enabled = false;
            this.services.sceneController.report(this.id, States_1.A.TRANSPARENT_TERRAIN, States_1.TURN.OFF);
            this.mapService.viewer.scene.camera.percentageChanged = 0.5;
        }
        if (this.mapService.viewer.scene.globe) {
            this.mapService.viewer.scene.globe.clippingPlanes = null;
        }
    }
}
GlobeController.meta = {
    label: 'PLUGINS.GLOBE_CONTROLLER.LABEL',
    name: 'globe-controller',
    translator: 'PLUGINS.GLOBE_CONTROLLER',
    tooltip: 'PLUGINS.GLOBE_CONTROLLER.TOOLTIP',
    shortcut: true,
    icon: 'globe',
    // offsetX: 'context',
    // offsetY: 'context',
    category: plugins_1.FdmPlugin.category.generic,
    types: [plugins_1.FdmPlugin.types.cameraController],
    cardinality: plugins_1.FdmPlugin.cardinality.one,
};
exports.GlobeController = GlobeController;
